import * as React from 'react';

import { Alert, Typography } from '@mui/material';
import { VerticalButtonPanel } from '../subs/ButtonPanel';
import { PageSection } from '../subs/PageSection';
import { WorkshopInfoPanel } from '../subs/WorkshopInfoPanel';

import VisibilityIcon from '@mui/icons-material/Visibility';
import { Page } from '../subs/Page';
import { Workshop, WorkshopStatus, getWorkshops } from '../types/Workshop';
import { formatDateString } from '../Web';
import { ButtonLink } from '../subs/ButtonLink';
import { getUserWorkshops } from '../types/User';
import { UserContext } from '../UserProvider';

const workshopFilterPredicate = (ws: Workshop) => {
    return ws.status === WorkshopStatus.Closed;
}

export const Results = () => {
    const debug = false;
    const userContext = React.useContext(UserContext);

    const [workshops, setWorkshops] = React.useState<Workshop[]>([]);
    const [workshopError, setWorkshopError] = React.useState<string | null>(null);

    React.useEffect(()=>{
        const fetch = async() => {
            const sharedAbortController = new AbortController();

            try {
                const userWorkshops = await getUserWorkshops(userContext.user?.id!!, sharedAbortController)
                const workshops = await getWorkshops(sharedAbortController);

                if(workshops.failed) {
                    setWorkshopError(workshops.errorText)
                    return;
                }

                if(userWorkshops.failed) {
                    setWorkshopError(workshops.errorText);
                    return;
                }

                setWorkshops(workshops.result.filter(ws => userWorkshops.result.find(uw => debug || uw.workshopId === ws.id) && workshopFilterPredicate(ws)));
            } catch(error) {
                setWorkshopError(String(error));
                console.log(error);
            }
        }
        
        fetch();
    }, [userContext]);

    const Info = () => <Alert severity='info'>{'There appear to be no workshops in this category.'}</Alert>

    return <Page heading='Results' errorComponent={workshopError?<Alert severity='error'>{workshopError}</Alert>:null}>
        <PageSection>
            {[<Typography>{"Below is a list of completed Workshops and their results. Please click on 'view' to see the results of the corresponding Workshop."}</Typography>]}
        </PageSection>
        
        {(workshops.length !== 0)? workshops.map(({id, name, location, startDate, endDate, contactEmail}) => {
            return (
                <PageSection heading={name}>
                    <WorkshopInfoPanel location={location}
                                    startDate={formatDateString(startDate) as string} 
                                    endDate={formatDateString(endDate) as string}
                                    supportMail={contactEmail} />
                    <VerticalButtonPanel heading={"My Results"}>
                        {[<ButtonLink to={`/WSTestingStart/${id}/true`} fullWidth startIcon={<VisibilityIcon />}>View</ButtonLink>]}
                    </VerticalButtonPanel>
{/*                     <VerticalButtonPanel heading={t('Results of', {company: 'Allmendinger IT-Solutions'})}>
                        {[<ButtonLink to={`/WSTestingStart/${id}/true`} fullWidth startIcon={<VisibilityIcon />}>View</ButtonLink>]}
                    </VerticalButtonPanel> */}
                </PageSection> )
            }
        ):<Info />}
    </Page>
}